import PropTypes from "prop-types"

import { cn } from "styles/utils"

import Image from "./image"

const mapSrcSetToAspectRatio = (srcSet) => {
  if (!srcSet?.length) return {}

  return srcSet.reduce(
    (accu, curr) => {
      const { height, media, width } = curr
      if (!height || !width) return accu

      if (media?.startsWith("(max-width:")) {
        accu = {
          className: `${accu.className} aspect-(--base-aspect-ratio)`,
          style: {
            ...accu.style,
            "--base-aspect-ratio": `${width} / ${height}`,
          },
        }
      } else if (media?.startsWith("(min-width: 768px)")) {
        accu = {
          className: `${accu.className} tablet:aspect-(--tablet-aspect-ratio)`,
          style: {
            ...accu.style,
            "--tablet-aspect-ratio": `${width} / ${height}`,
          },
        }
      } else if (media?.startsWith("(min-width: 1024px)")) {
        accu = {
          className: `${accu.className} desktop:aspect-(--desktop-aspect-ratio)`,
          style: {
            ...accu.style,
            "--desktop-aspect-ratio": `${width} / ${height}`,
          },
        }
      }

      return accu
    },
    { className: "", style: {} }
  )
}

const Picture = ({
  className,
  fallback,
  lazyload,
  srcSet,
  style,
  ...props
}) => {
  const { className: aspectClassName, style: aspectStyle } =
    mapSrcSetToAspectRatio(srcSet)

  return (
    <picture>
      {srcSet.map((src, i) => (
        <source
          height={src.height}
          key={`src-${i}`}
          media={src.media}
          sizes={src.sizes}
          type={src.type}
          width={src.width}
          {...(lazyload
            ? {
                "data-srcset": src.srcSet,
              }
            : {
                srcSet: src.srcSet,
              })}
        />
      ))}
      <Image
        className={cn("w-full", aspectClassName, className)}
        isPicture
        lazyload={lazyload}
        src={fallback}
        style={{ ...aspectStyle, ...style }}
        {...props}
      />
    </picture>
  )
}

Picture.defaultProps = {
  lazyload: true,
}

Picture.propTypes = {
  className: PropTypes.string,
  fallback: PropTypes.string,
  lazyload: PropTypes.bool,
  srcSet: PropTypes.array,
  style: PropTypes.object,
}

Picture.displayName = "Picture"

export default Picture
